import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { at } from 'lodash';
import { useField } from 'formik';
import { TEXT_PREFER_NOT_TO_SAY } from '../common/DataTypes';
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  Checkbox
} from '@mui/material';
import useStyles from './styles';

function SelectMultipleField2(props) {
  const classes = useStyles();
  const { label, data, filterOption, description, ...rest } = props;
  const [field, meta, includeNone] = useField(props);
  const { value: selectedValue } = field;
  const [touched, error] = at(meta, 'touched', 'error');
  const isError = touched && error && true;
  //const data2 = includeNone === true ? data : data.filter((item)=>item.indexOf(TEXT_PREFER_NOT_TO_SAY) == -1);
  //const data3 = data2 && data2.map(item=>{ return {label:item, value:item}});
  const data3 = data && data.map(item => { return { label: item, value: item } });
  function _renderHelperText() {
    if (isError) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  }

  const handleChange = (event) => {
    let selectedValue = event.target.value;
    if (selectedValue.indexOf(TEXT_PREFER_NOT_TO_SAY) > -1) {
      if (field.value.indexOf(TEXT_PREFER_NOT_TO_SAY) > -1) {
        event.target.value = selectedValue.filter((item) => item.indexOf(TEXT_PREFER_NOT_TO_SAY) < 0);
      } else {
        event.target.value = selectedValue.filter((item) => item.indexOf(TEXT_PREFER_NOT_TO_SAY) > -1);
      }

      field.onChange(event);
    } else {
      field.onChange(event);
    }
  };

  function _renderDescriptionText() {
    if (description) {
      return <p style={{color:'#0000008a', lineHeight:1.66, letterSpacing:0.033,padding:'4px 12px'}}>{description}</p>;
    }
  }

  return (
    <FormControl {...rest} error={isError} className={classes.multiSelect}>
      <InputLabel style={{ ...props.labelStyle }} className={props.labelClass ? classes.labelMultiline : classes.label}>{label}</InputLabel>
      <Select {...field} multiple
        style={{ fontSize: 14 }}
        autoComplete="off"
        renderValue={(selected) => (selected).join(', ')}
        onChange={handleChange}>
        {data3.map((item, index) => (
          <MenuItem key={index} value={item.value} style={{ fontSize: 14 }}>
            <Checkbox checked={selectedValue && selectedValue.indexOf(item.value) > -1} />
            {item.label}
          </MenuItem>
        ))}
      </Select>
      {_renderDescriptionText()}
      {_renderHelperText()}
    </FormControl>
  );
}

SelectMultipleField2.defaultProps = {
  data: []
};

SelectMultipleField2.propTypes = {
  data: PropTypes.array.isRequired
};

export default SelectMultipleField2;
